import { LegalAccountTaxationType } from '../../../../graphql/schema';

import type { FinancialSecurity } from '@betterment/shared-components/src/components/holdings/data';

type AggregatedPositionForRestrictions = {
  financialSecurity: { id: string };
  securityPositionsBySubAccount: {
    subAccount: { legalAccount: { taxationType: LegalAccountTaxationType } };
  }[];
};

type AccountForRestrictions = {
  securityGroupPositions: {
    securityPositionsBySecurity: AggregatedPositionForRestrictions[];
  }[];
};

function is401kTaxationType(taxationType: LegalAccountTaxationType): boolean {
  return (
    taxationType === LegalAccountTaxationType.Traditional_401K || taxationType === LegalAccountTaxationType.Roth_401K
  );
}

function isHeldExclusivelyBy401kAccounts(aggregatedPosition: AggregatedPositionForRestrictions): boolean {
  return aggregatedPosition.securityPositionsBySubAccount.every(sp =>
    is401kTaxationType(sp.subAccount.legalAccount.taxationType)
  );
}

function toFinancialSecurityId(aggregatedPosition: AggregatedPositionForRestrictions): string {
  return aggregatedPosition.financialSecurity.id;
}

export function determine401kRestrictions(
  account: AccountForRestrictions
): (financialSecurity: FinancialSecurity) => boolean {
  const restrictedIds = new Set(
    account.securityGroupPositions
      .flatMap(groupPosition => groupPosition.securityPositionsBySecurity)
      .filter(isHeldExclusivelyBy401kAccounts)
      .map(toFinancialSecurityId)
  );

  return (financialSecurity: FinancialSecurity) => restrictedIds.has(financialSecurity.id);
}
